// extracted by mini-css-extract-plugin
export var $animation_name = "Footer-module--$animation_name--f9994";
export var footer = "Footer-module--footer--d3994";
export var footer__main = "Footer-module--footer__main--42cb3";
export var footer__main___bar = "Footer-module--footer__main___bar--129f1";
export var footer__main___barLogos = "Footer-module--footer__main___barLogos--af129";
export var footer__main___barLogosDTY = "Footer-module--footer__main___barLogosDTY--e0f6f";
export var footer__main___barLogosdrinkAware = "Footer-module--footer__main___barLogosdrinkAware--dbfcf";
export var footer__main___barNote = "Footer-module--footer__main___barNote--153f6";
export var footer__main___bottom = "Footer-module--footer__main___bottom--d12c8";
export var footer__main___bottomDesktopMenus = "Footer-module--footer__main___bottomDesktopMenus--ac3f0";
export var footer__main___bottomMenus = "Footer-module--footer__main___bottomMenus--0a0f4";
export var footer__main___bottomMenusTitle = "Footer-module--footer__main___bottomMenusTitle--99339";
export var footer__main___bottomTrigger = "Footer-module--footer__main___bottomTrigger--37e57";
export var footer__main___top = "Footer-module--footer__main___top--1a93d";
export var footer__main___topLogo = "Footer-module--footer__main___topLogo--22223";
export var footer__main___topMenu = "Footer-module--footer__main___topMenu--f04e7";
export var footer__main___topMenuItem = "Footer-module--footer__main___topMenuItem--040f0";
export var footer__sidebar = "Footer-module--footer__sidebar--3d1c1";
export var footer__sidebar___cta = "Footer-module--footer__sidebar___cta--d7854";
export var footer__sidebar___ctaArrow = "Footer-module--footer__sidebar___ctaArrow--db8b1";